import { useState, useMemo } from 'react'
import { IconUploadDefault, Button } from '@mc/design-system'
import { useTranslation } from '@mc/i18n'
import { ShareContextData, ShareModal, SOURCES } from '@mc/share'
import { ACTIONS, trackAction, TrackProps } from '../events'

export interface ShareProps {
  instructorName: string
  headline: string
  id: string | number
  slug: string
  source: (typeof SOURCES)[keyof typeof SOURCES]
}

const ShareAction = ({
  trackProps,
  share,
}: {
  trackProps: TrackProps
  share?: ShareProps
}) => {
  const { t } = useTranslation('@mc/next')
  const [isModalOpen, setIsModalOpen] = useState(false)
  const { slug, instructorName, headline, id, source } = share || {}

  const shareData = useMemo(
    () => ({
      course: { slug, instructorName, id },
      title: `${instructorName} ${headline}`,
      source,
    }),
    [headline, slug, instructorName, id, source],
  )

  const handleClick = () => {
    trackAction(trackProps, ACTIONS.SHARE)
    setIsModalOpen(true)
  }

  return (
    <>
      <Button
        kind='link'
        className='d-inline-flex flex-column'
        onClick={handleClick}
      >
        <IconUploadDefault className='mc-icon--4 mc-mb-4' size='lg' />
        {t('course.share')}
      </Button>

      <ShareModal
        show={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        shareData={shareData as ShareContextData}
        useDeprecated
      />
    </>
  )
}

export default ShareAction
